import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MarkantElementsModule } from '@markant/elements-angular';
import { TranslocoPipe } from '@jsverse/transloco';
import { FormControlErrorPipe, FormControlKeyErrorPipe } from '@markant-platform/shared/util-pipes';

@Component({
  selector: 'markant-platform-support-form-error',
  templateUrl: './support-form-error.component.html',
  styleUrls: ['./support-form-error.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, MarkantElementsModule, TranslocoPipe, FormControlErrorPipe, FormControlKeyErrorPipe],
})
export class SupportFormErrorComponent {
  @Input() formGroup!: FormGroup;
  @Input() loading = false;
  @Output() cancel = new EventEmitter<void>();
  @Output() submitForm = new EventEmitter<void>();

  isTouched(controlName: string): boolean {
    const control = this.formGroup.get(controlName);
    return control ? control.touched || control.dirty : false;
  }

  onCancel(): void {
    this.cancel.emit();
  }

  onSubmit(): void {
    if (this.formGroup.valid) {
      this.submitForm.emit();
    } else {
      this.formGroup.markAllAsTouched();
    }
  }
}
